import { useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useCrmSocket } from "@/pages/crm/socket";

const RB = `${process.env.REACT_APP_BACKEND_URL}/api/rcrm`;
const seen = new Set();

// Two short rising tones — no asset needed; silently ignored if audio is blocked.
export function beep() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    const ctx = new Ctx();
    const o = ctx.createOscillator(), g = ctx.createGain();
    o.type = "sine"; o.frequency.value = 880; g.gain.value = 0.07;
    o.connect(g); g.connect(ctx.destination);
    o.start(); o.frequency.setValueAtTime(1175, ctx.currentTime + 0.15); o.stop(ctx.currentTime + 0.35);
  } catch { /* audio not available */ }
}

/** Show the bell alert for one follow-up reminder (deduped per lead+time). Returns true if shown. */
export function fireFollowupAlert(d, navigate) {
  const key = `${d.lead_id}|${d.due_at}`;
  if (seen.has(key)) return false;
  seen.add(key);
  beep();
  const title = `⏰ Follow-up in ${d.minutes} min — ${d.student_name}`;
  const desc = [d.phone, d.remark].filter(Boolean).join(" · ");
  toast(title, { id: key, description: desc, duration: 20000, action: { label: "Open follow-ups", onClick: () => navigate("/crm/followups") } });
  if ("Notification" in window && Notification.permission === "granted") {
    try { new Notification(title, { body: desc }); } catch { /* ignore */ }
  }
  return true;
}

/** Realtime push + 60 s heartbeat so the alert lands ~10 minutes before every follow-up, on any screen. */
export function useFollowupAlarms(enabled, navigate, onFired) {
  useCrmSocket(enabled ? "followup:reminder" : null, (d) => {
    if (d?.owner_id && d.owner_id === localStorage.getItem("rcrm_uid") && fireFollowupAlert(d, navigate)) onFired?.();
  });
  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    const check = async () => {
      const t = localStorage.getItem("rcrm_token");
      if (!t) return;
      try {
        const r = await axios.post(`${RB}/followups/alarms/check`, {}, { headers: { Authorization: `Bearer ${t}` } });
        if (!alive) return;
        let any = false;
        (r.data.items || []).forEach((d) => { if (fireFollowupAlert(d, navigate)) any = true; });
        if (any) onFired?.();
      } catch { /* offline or no CRM access */ }
    };
    check();
    const id = setInterval(check, 60000);
    return () => { alive = false; clearInterval(id); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);
}
